var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519938 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0ZM15.4137 7.80947C15.4137 8.03526 15.319 8.12526 15.0979 8.12526C14.6732 8.12526 14.2484 8.12526 13.8253 8.14263C13.4021 8.16 13.1716 8.35263 13.1716 8.79474C13.1621 9.26842 13.1716 9.73263 13.1716 10.2158H14.989C15.2479 10.2158 15.3363 10.3042 15.3363 10.5647C15.3363 11.1963 15.3363 11.8311 15.3363 12.4689C15.3363 12.7263 15.2542 12.8068 14.9937 12.8084H13.1558V17.9463C13.1558 18.2211 13.0705 18.3079 12.799 18.3079H10.8221C10.5837 18.3079 10.4905 18.2147 10.4905 17.9763V12.8163H8.92106C8.67474 12.8163 8.58632 12.7263 8.58632 12.4784C8.58632 11.8395 8.58632 11.2011 8.58632 10.5632C8.58632 10.3168 8.67948 10.2237 8.92264 10.2237H10.4905V8.84211C10.4719 8.22151 10.6208 7.60737 10.9216 7.06421C11.2342 6.51585 11.7352 6.09957 12.3316 5.89263C12.7186 5.75181 13.1277 5.68123 13.5395 5.68421H15.0916C15.3142 5.68421 15.4074 5.78211 15.4074 6C15.4153 6.60789 15.4153 7.20947 15.4137 7.80947Z",
    fill: "#1A365D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/icon-facebook.3db837690ca12cbec0b5ebbaf7a3d786.svg";
export { ForwardRef as ReactComponent };